import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Settings", -1)
const _hoisted_5 = { class: "mt-4 d-flex justify-content-between align-items-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save fa-fixed me-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save settings ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "d-flex flex-column align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Re-authenticate app", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "modal show",
  tabindex: "-1",
  style: {"display":"block"}
}
const _hoisted_17 = { class: "modal-dialog" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Remove app", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this app?")
], -1)
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.settingsComponent)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.settingsComponent), {
              key: 0,
              app: _ctx.app,
              onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveSettings(false))),
              ref: "settingsComp"
            }, null, 40, ["app"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.hasSettings)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-success",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveSettings(true)))
              }, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeApp && _ctx.removeApp(...args)))
            }, _hoisted_13),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                                _ctx.$router.push({ name: _ctx.availableApps[_ctx.app.app_name].install.route, params: Object.assign({ appId: _ctx.$route.params.appId }, _ctx.availableApps[_ctx.app.app_name].install.params) })
                            ), ["prevent"])),
              href: "#"
            }, _hoisted_15)
          ])
        ])
      ])
    ]),
    (_ctx.removeModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeModal = false))
                })
              ]),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeModal = false))
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeAppConfirm && _ctx.removeAppConfirm(...args)))
                }, _hoisted_25)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}